import React from "react";
import methodModel from "../../../methods/methods";
import { Link } from "react-router-dom";
import "./style.scss";
import Layout from "../../global/layout";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Pagination from "react-pagination-js";
import MultiSelectDropdown from "../../common/MultiSelectDropdown";
import { IoCloseOutline } from "react-icons/io5";
import { FiEdit, FiInstagram } from "react-icons/fi";
import { FaFacebook, FaTwitter } from "react-icons/fa";

const Html = ({
  user,
  handleSubmit,
  setForm,
  form,
  getError,
  uploadImage,
  submitted,
  filters, total, filter,
  products,
  productCheck,
  productLoader,
  productSelectValues,
  pageChange,
  affiliateTypeCategories
}) => {

  return (
    <Layout>
      <div className="max-w-[1200px] mx-auto">
          <h2 className="background_text text-[45px] sm:text-[55px] leading-[60px] font-semibold mb-5">Profile</h2>
        <form onSubmit={handleSubmit} className="">
          <div className="flex max-lg:flex-wrap gap-5">
            <div class="w-full lg:max-w-[350px] w-full bg-white shadow-lg text-center p-5 sm:p-8">
              <div className="">
                <div className="relative w-fit h-fit mx-auto">
                <img
                  src={methodModel.userImg(form && form.image)}
                  className="w-28 h-28 mx-auto rounded-full border-4 border-[#115B9D] object-cover"
                />
                     {form.image ? (
                <IoCloseOutline onClick={(e) => setForm({ ...form, image: "" })} className="absolute right-[8px] bottom-[5px] w-[22px] h-[22px] text-red rounded-full border border-red cursor-pointer hover:bg-[#ffefef] bg-white p-[2px]" />
                ) : (
                  <></>
                )}
                </div>
                <div className="space-y-2 mt-4">
                  <h2 class="text-2xl font-bold text-gray-800">
                    John Doe
                  </h2>
                  <p class="text-gray-500">
                    @johndoe
                  </p>
                  <p class="text-gray-600 text-sm">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                  </p>
                </div>
                <label className="!px-4 w-full text-sm font-[600] text-white h-10 flex items-center justify-center gap-2 !bg-[#115B9D] rounded-xl shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] cursor-pointer disabled:bg-[#D0CAF6] disabled:cursor-not-allowed mt-5">
                  <input
                    id="bannerImage"
                    type="file"
                    className="hidden"
                    accept="image/*"
                    value={form.baseImg ? form.baseImg : ""}
                    onChange={(e) => {
                      uploadImage(e);
                    }}
                  />
                  {form.image ? "Change" : "Upload"} Image
                </label>
              </div>
            

            </div>
            <div className="w-full bg-white shadow-lg p-5 sm:p-8">
              <div className="flex items-center gap-5 justify-between border-b pb-4 mb-4">
              <h2 className="text-2xl font-semibold text-[#111827]">Basic Information</h2>
              </div>
              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-12 sm:col-span-6">
                  <label className="text-sm font-medium">
                    Name<span className="star">*</span>
                  </label>
                  <div className="">
                    <input
                      type="text"
                      className="shadow-box border !border-grey bg-white w-full text-sm placeholder:text-gray-500 rounded-large h-10 flex items-center gap-2 overflow-hidden px-3 !ring-[#115B9D] !outline-[#115B9D]"
                      placeholder="Enter Name"
                      value={form.fullName ? form.fullName : ""}
                      onChange={(e) =>
                        setForm({ ...form, fullName: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6">
                  <label className="text-sm font-medium">Email</label>
                  <div className="">
                    <input
                      type="email"
                      className="shadow-box border !border-grey bg-white w-full text-sm disabled:bg-gray-100 placeholder:text-gray-500 rounded-large h-10 flex items-center gap-2 overflow-hidden px-2 !ring-[#115B9D] !outline-[#115B9D]"
                      placeholder="Enter Email"
                      value={form.email ? form.email : ""}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6">
                  <label className="text-sm font-medium">
                    Mobile No
                  </label>
                  <div className="">
                    <div className="form-row">
                      <div className="col-md-12">
                        <PhoneInput
                          required
                          enableSearch={true}
                          autoFormat={false}
                          placeholder="Enter phone number"
                          value={form?.mobileNo}
                          countryCodeEditable={true}
                          onChange={(e) => setForm({ ...form, mobileNo: e })}
                          buttonClass="!border border-grey !roundehidden !bg-tranparent !rounded-l-large"
                          inputClass="shadow-box border !rounded-large !border-grey !min-h-10 text-sm placeholder:text-gray-500 flex items-center gap-2 overflow-hidden !px-2 !pl-12 !ring-[#115B9D] !outline-[#115B9D]"
                        />
                      </div>
                    </div>
                    {submitted &&
                      getError("mobileNo").invalid &&
                      !getError("dialCode").invalid ? (
                      <div className="invalid-feedback d-block">
                        Min Length is 10
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="col-span-12">
                  <label className="text-sm font-medium">
                    Address
                  </label>
                  <div className="">
                    <input
                      type="text"
                      value={form.address ? form.address : ""}
                      onChange={(e) =>
                        setForm({ ...form, address: e.target.value })
                      }
                      className="shadow-box border !border-grey bg-white w-full text-sm placeholder:text-gray-500 rounded-large h-10 flex items-center gap-2 overflow-hidden px-3 !ring-[#115B9D] !outline-[#115B9D]"
                      placeholder="Enter Address"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-4 justify-end mt-5">
            <button type="submit" className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5">
              Update
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default Html;
